module.exports = __webpack_public_path__ + "static/img/pingTaiBox2.755b00c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pingTaiBox2.png
// module id = lEUp
// module chunks = 2